import { IAcceptanceDetails, ILCHttpResponse } from '@logicalcommander/types'
import { createApi } from '@reduxjs/toolkit/query/react'
import { v4 as uuidv4 } from 'uuid'
import { configManager } from '../../config/configManager'
import { RootState } from '../redux/store'
import { createBaseQueryWithErrorHandling } from './baseQueryWithErrorHandling'

export interface IActivityLogEntry {
  identity: string
  ipAddress: string
  fullName: string
  roles: string
  outcome: string
  details: {
    action: string
  }
  createdAt: Date
}

export const acceptanceApi = createApi({
  reducerPath: 'acceptanceApi',
  baseQuery: createBaseQueryWithErrorHandling(`${configManager.api.GATEWAY_URL}/acceptance`, (headers, { getState }) => {
    headers.set('x-request-id', uuidv4())
    const { token, companyToken } = (getState() as RootState).authReducer
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    if (companyToken) {
      headers.set('x-company-token', companyToken)
    }
    return headers
  }),
  endpoints: (builder) => ({
    acceptTermsAndConditions: builder.mutation<
      IAcceptanceDetails,
      { version: string; docType: string; token: string; companyToken: string }
    >({
      query: ({ token, companyToken, docType, version }) => ({
        headers: [
          ['authorization', `Bearer ${token}`],
          ['x-company-token', companyToken],
        ],
        url: `/accept-terms/${docType}/${version}`,
        method: 'POST',
      }),
      transformResponse: (rawResult: ILCHttpResponse<IAcceptanceDetails>) => {
        return rawResult.data as IAcceptanceDetails
      },
    }),
  }),
})

export const { useAcceptTermsAndConditionsMutation } = acceptanceApi
